'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oem_main.mail_template', {
        url: '/mail_template',
        template: '<mail-template></mail-template>'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/mail_template/mail_template.route.js